import {
    CREATE_PURCHASE_ORDER,
    DELETE_PURCHASE_ORDER,
    GET_PURCHASE_ORDERS,
    GET_PURCHASE_ORDERS_PAGE,
    PURCHASE_ORDER_REQUEST,
    PURCHASE_ORDER_REQUEST_SUCCESS,
    PURCHASE_ORDER_REQUEST_FAILURE,
    UPDATE_PURCHASE_ORDER
  } from "../types";
  
  const initialState = {
    purchaseOrders: [],
    purchaseOrdersPage: [],
    page: 1,
    pageSize: 10,
    search: '',
    where: {},
    total: 0,
    loading: false,
    error: null,
  };
  
  const purchaseOrderReducer = (state = initialState, action) => {
    switch (action.type) {
      case PURCHASE_ORDER_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_PURCHASE_ORDERS: {
        return {
          ...state,
          purchaseOrders: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_PURCHASE_ORDERS_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          purchaseOrdersPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_PURCHASE_ORDER:
        return {
          ...state,
          purchaseOrders: [action.payload, ...state.purchaseOrders],
          loading: false,
          error: null
        };
      case UPDATE_PURCHASE_ORDER:
        const purchaseOrdersData = state.purchaseOrders.slice(0);
        const uIndex = purchaseOrdersData.findIndex((data) => data.id === action.payload.id);
        purchaseOrdersData.splice(uIndex, 1, { ...action.payload.data });
        return {
          ...state,
          purchaseOrders: [ ...purchaseOrdersData ],
          loading: false,
          error: null
        };
      case DELETE_PURCHASE_ORDER:
        const purchaseOrders = state.purchaseOrders?.slice(0);
        const index = purchaseOrders.findIndex((data) => data.id === action.id);
        if (index > -1) {
          purchaseOrders.splice(index, 1);
        }
        return {
          ...state,
          purchaseOrders: [...purchaseOrders],
          loading: false,
          error: null
        }
      case PURCHASE_ORDER_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case PURCHASE_ORDER_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default purchaseOrderReducer;
  